import {provideHttpClient, withInterceptors} from "@angular/common/http";
import {ApplicationConfig, InjectionToken, isDevMode} from "@angular/core";
import {provideRouter, withComponentInputBinding} from "@angular/router";
import {provideState, provideStore} from "@ngrx/store";
import {provideStoreDevtools} from "@ngrx/store-devtools";
import {authInterceptor, provideAuth} from "angular-auth-oidc-client";
import {environment} from "src/environments/environment";
import {routes} from "./app.routes";
import {buildAssetManagementUrl} from "./helpers";
import {versionHeadersInterceptor} from "./interceptors";
import {apiGatewayHeaderInterceptor} from "./interceptors/api-gateway-header.interceptor";
import {assetsFeature, assetTypesFeature, technologiesFeature} from "./store/reducers";
import {authFeature} from "./store/reducers/auth.reducer";
import {customersFeature} from "./store/reducers/customers.reducer";
import {trumpfCompaniesFeature} from "./store/reducers/trumpf-companies.reducer";
import {usersFeature} from "./store/reducers/users.reducer";
import {countryFeature} from "./store/reducers/countries.reducer";

export const ASSET_MANAGEMENT_URL = new InjectionToken("asset_management.url");

const provideStates = () => [
  provideState(assetTypesFeature),
  provideState(assetsFeature),
  provideState(technologiesFeature),
  provideState(authFeature),
  provideState(trumpfCompaniesFeature),
  provideState(customersFeature),
  provideState(usersFeature),
  provideState(countryFeature)
];

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(withInterceptors([authInterceptor(), versionHeadersInterceptor, apiGatewayHeaderInterceptor])),
    provideAuth({
      config: environment.authConfig
    }),
    provideStore(),
    provideStates(),
    provideStoreDevtools({
      maxAge: 25, // Retains last 25 states
      logOnly: !isDevMode(), // Restrict extension to log-only mode
      autoPause: true, // Pauses recording actions and state changes when the extension window is not open
      trace: false, //  If set to true, will include stack trace for every dispatched action
      traceLimit: 75, // maximum stack trace frames to be stored (in case trace option was provided as true)
      connectInZone: true // If set to true, the connection is established within the Angular zone
    }),
    {
      provide: ASSET_MANAGEMENT_URL,
      useValue: buildAssetManagementUrl(environment)
    }
  ]
};
